var $1e7b09e4a9416c26$exports = {};
async function $1e7b09e4a9416c26$var$loadComponent(id, path) {
    const res = await fetch(path);
    const html = await res.text();
    document.getElementById(id).innerHTML = html;
}
const $1e7b09e4a9416c26$var$scrollButton = document.querySelector(".scroll-button");
if ($1e7b09e4a9416c26$var$scrollButton) $1e7b09e4a9416c26$var$scrollButton.addEventListener("click", ()=>{
    const servicesSection = document.querySelector("#services");
    servicesSection.scrollIntoView({
        behavior: "smooth",
        block: "start"
    });
});
window.toggleService = function(element) {
    const card = element.closest(".service-card");
    card.classList.toggle("expanded");
};
document.addEventListener("click", (event)=>{
    const navToggle = event.target.closest(".nav-toggle");
    const dropdownToggle = event.target.closest(".nav-dropdown-toggle");
    const openDropdown = document.querySelector(".nav-dropdown.open");
    const navLinks = document.getElementById("nav-links");
    if (navToggle) {
        const isOpen = navLinks.classList.toggle("open");
        navToggle.setAttribute("aria-expanded", isOpen);
        return;
    }
    if (dropdownToggle) {
        const dropdown = dropdownToggle.closest(".nav-dropdown");
        const isOpen = dropdown.classList.toggle("open");
        dropdownToggle.setAttribute("aria-expanded", isOpen);
        if (openDropdown && openDropdown !== dropdown) {
            openDropdown.classList.remove("open");
            openDropdown.querySelector(".nav-dropdown-toggle").setAttribute("aria-expanded", "false");
        }
        return;
    }
    if (openDropdown && !event.target.closest(".nav-dropdown")) {
        openDropdown.classList.remove("open");
        openDropdown.querySelector(".nav-dropdown-toggle").setAttribute("aria-expanded", "false");
    }
    if (navLinks && navLinks.classList.contains("open") && event.target.closest(".nav-links a")) {
        navLinks.classList.remove("open");
        document.querySelector(".nav-toggle").setAttribute("aria-expanded", "false");
    }
});
document.addEventListener("DOMContentLoaded", ()=>{
    $1e7b09e4a9416c26$var$loadComponent("header", "/components/header.html");
    $1e7b09e4a9416c26$var$loadComponent("footer", "/components/footer.html");
    const video = document.querySelector("video");
    const videoBackground = document.querySelector(".video-background");
    video.play().catch(function(error) {
        videoBackground.classList.add("image-fallback");
        video.remove();
    });
});


//# sourceMappingURL=index.be5d74ac.js.map
